import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Pagos } from './pagos';

@Injectable({
  providedIn: 'root'
})
export class AbonosService {

  constructor(private http: HttpClient) { }

  getAbonos(id:string) {  
  
    return this.http.get<Pagos[]>(environment.apiUrl+"/listaPagos/?id="+id);  
  }  


  eliminarCliente(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarPagos/?id="+id);
  }
  

  guardarPagos(pagosList: Pagos[]){
    console.log(pagosList);
    return this.http.put<string>(environment.apiUrl+"/actulizarPagos",pagosList);
  }



}
